import type { Role } from "@/constants/navigation";

export enum DispatcherPermissionValue {
  ViewChat = "view_chat",
  SendMessages = "send_messages",
  ControlChat = "control_chat",
  TransferBetweenDispatchers = "transfer_between_dispatchers",

  ViewTripMonitor = "view_trip_monitor",
  ClaimTrip = "claim_trip",
  HeadClaimTrip = "head_claim_trip",
  EditOrCreateCheckCalls = "edit_or_create_check_calls",
  ViewCheckCalls = "view_check_calls",
  CreateBrokerUpdate = "create_broker_update",
  ViewBrokerUpdates = "view_broker_updates",

  ViewDispatchers = "view_dispatchers",
  EditOrCreateDispatcher = "edit_or_create_dispatcher",
  ArchiveDispatcher = "archive_dispatcher",

  ViewUsers = "view_users",
  ViewUserInfo = "view_user_info",
  EditOrCreateUser = "edit_or_create_user",
  ArchiveUser = "archive_user",

  EditOrCreateOrder = "edit_or_create_order",
  ViewOrderInfo = "view_order_info",
  ViewOrders = "view_orders",

  EditOrCreateTrip = "edit_or_create_trip",
  ViewTripInfo = "view_trip_info",
  ProcessTrip = "process_trip",

  ViewCompanies = "view_companies",
  EditOrCreateCompany = "edit_or_create_company",

  ViewTrucks = "view_trucks",
  ViewTruckInfo = "view_truck_info",
  EditOrCreateTruck = "edit_or_create_truck",
  ReserveTruck = "reserve_truck",
  ArchiveTruck = "archive_truck",
  ChangeTruckStatus = "change_truck_status",
  AccessToTruckSearch = "access_to_truck_search",

  CreateReport = "create_report",
  AccessToBilling = "access_to_billing",
}

export enum DispatcherPermissionName {
  ViewChat = "View chat",
  SendMessages = "Send messages",
  ControlChat = "Control chat",
  TransferBetweenDispatchers = "Transfer between dispatchers",

  ViewTripMonitor = "View trip monitor",
  ClaimTrip = "Claim trip",
  HeadClaimTrip = "Head claim trip",
  EditOrCreateCheckCalls = "Edit or create check calls",
  ViewCheckCalls = "View check calls",
  CreateBrokerUpdate = "Create broker update",
  ViewBrokerUpdates = "View broker updates",

  ViewDispatchers = "View dispatchers",
  EditOrCreateDispatcher = "Edit or create dispatcher",
  ArchiveDispatcher = "Archive dispatcher",

  ViewUsers = "View users",
  ViewUserInfo = "View user info",
  EditOrCreateUser = "Edit or create user",
  ArchiveUser = "Archive user",

  EditOrCreateOrder = "Edit or create order",
  ViewOrderInfo = "View order info",
  ViewOrders = "View orders",

  EditOrCreateTrip = "Edit or create trip",
  ViewTripInfo = "View trip info",
  ProcessTrip = "Process trip",

  ViewCompanies = "View companies",
  EditOrCreateCompany = "Edit or create company",

  ViewTrucks = "View trucks",
  ViewTruckInfo = "View truck info",
  EditOrCreateTruck = "Edit or create truck",
  ReserveTruck = "Reserve truck",
  ArchiveTruck = "Archive truck",
  ChangeTruckStatus = "Change truck status",
  AccessToTruckSearch = "Access to truck search",

  CreateReport = "Create report",
  AccessToBilling = "Access to billing",
}

export interface DispatcherPermission {
  name: DispatcherPermissionName;
  value: DispatcherPermissionValue;
}

export interface DispatcherPermissionGroupItem {
  group: DispatcherPermissionGroup;
  permissions: DispatcherPermission[];
}

export enum DispatcherPermissionGroup {
  Chat = "Chat",
  TripMonitor = "Trip Monitor",
  Dispatchers = "Dispatchers",
  Users = "Users",
  Orders = "Orders",
  Trips = "Trips",
  Companies = "Companies",
  Trucks = "Trucks",
  Billing = "Billing",
}

export interface CurrentDispatcher {
  id: number | null;
  name: string | null;
  firstName: string;
  lastName: string;
  roles: Role[];
  phone: string | null;
  phoneExt: string | null;
  timezone: string;
  company: DispatcherCompanyDto;
  isSuperAdmin: boolean;
  allExistingPermissions: DispatcherPermissionGroupItem[];
  permissions: DispatcherPermissionValue[];
}

export interface DispatcherCompanyDto {
  id: number;
  name: string;
  code: string;
}
